import endpoint from "../../config/endpoints";

export const AdvanceOutletInvoicingFooterJsons = {
  showSaveNextBtn: false,
  apiBaseURL: endpoint.room,
  formPath: "",
  screenTitle: "",
  showTitle: false,
  showCancel: false,
  showSaveBtn: false,
  fieldMeta: [],
};
